import { Injectable, EventEmitter, Inject } from '@angular/core';
//import { LocalizedString } from '../course/localized-string';
//import * as _ from 'lodash';
import { environment } from '../../environments/environment';
//import { Name } from '../organisation/name';
import { DOCUMENT } from '@angular/common';
import { LocalizedString } from '@angular/compiler';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn:  'root'
})
export class Globals {

  static LocalizedString = class {
    valueFi: string = "";
    valueEn: string = "";
    valueSv: string = "";
  }
    
  lang = environment.primaryLang;
  // https://stackoverflow.com/questions/34700438/global-events-in-angular
  langChanged: EventEmitter<string>; // global event
  schoolYearChanged: EventEmitter<number>;
  curriculumPeriodChanged: EventEmitter<string>;
  /*primaryLanguage = AppConfig.PRIMARY_LANGUAGE;
  secondaryLanguage = AppConfig.SECONDARY_LANGUAGE;
  tertiaryLanguage = AppConfig.TERTIARY_LANGUAGE*/
  languages = [environment.primaryLang, environment.secondaryLang, environment.tertiaryLang];
  spring = {valueFi: 'k', valueEn: 's', valueSv: 'v'};
  autumn = {valueFi: 's', valueEn: 'a', valueSv: 'h'};
  academicYear = {valueFi: 'lv', valueEn: 'ay', valueSv: 'lå'};
  // tämä on testi
  currentUrl = new Globals.LocalizedString();
  selectedSchoolYear!: number;
  selectedCurriculumPeriod!: string;

  private link!: HTMLLinkElement;

  constructor(
    @Inject(DOCUMENT) private document: Document
  ) {
    this.langChanged = new EventEmitter();
    this.schoolYearChanged = new EventEmitter();
    this.curriculumPeriodChanged = new EventEmitter(); 
  //  this.currentUrl = {valueFi: '/', valueEn: '/', valueSv: '/'};
  //  this.createLinkForCanonicalURL();
  }

  setLang(value: string): void {
   // console.log('lang changed');
    this.lang = value;
    this.langChanged.emit(value);
    //muutetaan canonical url keskitetysti tässä
   // console.log('kutsuttiin canonicalia globalsissta');
   // this.createLinkForCanonicalURL();
  }

  createLinkForCanonicalURL() {
    
    if (this.link === undefined) {
      this.link = this.document.createElement('link');
      this.link.setAttribute('rel', 'canonical');
      this.document.head.appendChild(this.link);
    }
    
    this.link.setAttribute('href', window.location.protocol +'//'+ window.location.host + this.getCurrentUrl(this.lang) );
    //console.log('canonicalUrl: ' + window.location.protocol +'//'+ window.location.host + this.getCurrentUrl(this.lang));
  }

  /*getSelectedSchoolYear(): number {
    return this.selectedSchoolYear;
  }*/

  setSelectedSchoolYear(value: number): void {
    this.selectedSchoolYear = value;
    this.schoolYearChanged.emit(value);
  }

  setSelectedCurriculumPeriod(value: string): void {
    this.selectedCurriculumPeriod = value;
    this.curriculumPeriodChanged.emit(value);
  }

  
 sortMapValuesByName(obj: any, lang: string): any[] {
  let field: string;
  if (lang === 'fi') field = 'valueFi';
  else if (lang === 'en') field = 'valueEn';
  else if (lang === 'sv') field = 'valueSv';
  else field = 'valueFi';

  const entries = Object.entries(obj);
  const zero = entries.find(([key]) => key === '0');
  const rest = entries.filter(([key]) => key !== '0');

  rest.sort((a: any, b: any) => {
    const nameA = a[1][field] ?? '';
    const nameB = b[1][field] ?? '';
    return nameA.localeCompare(nameB, lang, { sensitivity: 'base' });
  });

  return zero ? [zero[1], ...rest.map(([_, v]) => v)] : rest.map(([_, v]) => v);
}


  // tätä käytetään vain organisaatioiden kanssa, koska niillä on määritelty nimi aina myös englanniksi
  sortByName(list: Array<any>, lang: string) {
    if (lang == 'fi') {
      list.sort((a, b) => {
        if (a.name.valueFi < b.name.valueFi) {
          return -1;
        } else if (a.name.valueFi > b.name.valueFi) {
         return 1;
        } else {
          return 0;
        }
      });
    }
    if (lang == 'en') {
      list.sort((a, b) => {
        if (a.name.valueEn < b.name.valueEn) {
          return -1;
        } else if (a.name.valueEn > b.name.valueEn) {
          return 1;
        } else {
          return 0;
        }
      });
    }
    if (lang == 'sv') {
      list.sort((a, b) => {
        if (a.name.valueSv < b.name.valueSv) {
          return -1;
        } else if (a.name.valueSv > b.name.valueSv) {
          return 1;
        } else {
          return 0;
        }
      });
    }
  }

  sortByName2(list: Array<any>, lang: string) {
    if (lang === 'fi') {
      list.sort((a, b) => {
        if (a.name.valueFi < b.name.valueFi) {
          return -1;
        } else if (a.name.valueFi > b.name.valueFi) {
         return 1;
        } else {
          return 0;
        }
      });
    }
    if (lang === 'en') {
      list.sort((a, b) => {
        if (a.name.valueEn === '' || b.name.valueEn === '') {
          if (a.name.valueEn === '' && b.name.valueEn === '') {
            // oletuskieli suomi
            if (environment.primaryLang === 'fi') {
              if (a.name.valueFi < b.name.valueFi) {
                return -1;
              } else if (a.name.valueFi > b.name.valueFi) {
                return 1;
              } else {
                return 0;
              }
            }
            // oletuskieli ruotsi
            if (environment.primaryLang === 'sv') {
              if (a.name.valueSv < b.name.valueSv) {
                return -1;
              } else if (a.name.valueSv > b.name.valueSv) {
                return 1;
              } else {
                return 0;
              }
            }
          }
          if (a.name.valueEn === '') {
            // oletuskieli suomi
            if (environment.primaryLang === 'fi') {
              if (a.name.valueFi < b.name.valueEn) {
                return -1;
              } else if (a.name.valueFi > b.name.valueEn) {
                return 1;
              } else {
                return 0;
              }
            }
            // oletuskieli ruotsi
            if (environment.primaryLang === 'sv') {
              if (a.name.valueSv < b.name.valueEn) {
                return -1;
              } else if (a.name.valueSv > b.name.valueEn) {
                return 1;
              } else {
                return 0;
              }
            }
          }
          if (b.name.valueEn === '') {
            // oletuskieli suomi
            if (environment.primaryLang === 'fi') {
              if (a.name.valueEn < b.name.valueFi) {
                return -1;
              } else if (a.name.valueEn > b.name.valueFi) {
                return 1;
              } else {
                return 0;
              }
            }
            // oletuskieli ruotsi
            if (environment.primaryLang === 'sv') {
              if (a.name.valueEn < b.name.valueSv) {
                return -1;
              } else if (a.name.valueEn > b.name.valueSv) {
                return 1;
              } else {
                return 0;
              }
            }
          }
        } else {
          if (a.name.valueEn < b.name.valueEn) {
            return -1;
          } else if (a.name.valueEn > b.name.valueEn) {
            return 1;
          } else {
            return 0;
          }
          
        }
        return 0;
      });
    } 
    if (lang === 'sv') {
      list.sort((a, b) => {
        if (a.name.valueSv < b.name.valueSv) {
          return -1;
        } else if (a.name.valueSv > b.name.valueSv) {
          return 1;
        } else {
          return 0;
        }
      });
    }
  }
/**/
  getLocalizedValue(value: any): any {
    if (this.lang === 'fi') {
      return value?.valueFi;
    }
    if (this.lang === 'en') {
      return value?.valueEn;
    }
    if (this.lang === 'sv') {
      return value?.valueSv;
    }
  }

  getLocalizedNavigationItem(value: any): any {
    if (this.lang === 'fi') {
      return value?.valueFi;
    }
    if (this.lang === 'en') {
      return value?.valueEn;
    }
    if (this.lang === 'sv') {
      return value?.valueSv;
    }
  }

  getLocalizedValueForTitle(value: any): any {
    if (this.lang === 'fi') {
      return value?.valueFi;
    }
    // jos engl. nimikenttä on tyhjä, näytetään jaksoilla suomenkielinen (=pääkielinen) nimi
    if (this.lang === 'en') {
      if (value?.valueEn === '') {
        if (environment.primaryLang === 'fi') {
          return value?.valueFi;
        }
        if (environment.primaryLang === 'sv') {
          return value?.valueSv;
        }
      } else {
        // kun nimikenttä ei ole tyhjä
        return value?.valueEn;
      }
    }
    // svenska
    if (this.lang === 'sv') {
      return value?.valueSv;
    }
  }

  getLocalizedValueIfAny(value: any): any {
    if (this.lang === 'fi') {
      if (value?.valueFi === '') {
          return value?.valueEn;
      } else {
        return value?.valueFi;
      }
      return ""
    }

    if (this.lang === 'en') {
      if (value?.valueEn === '') {
        return (!(value?.valueFi === '') ? value?.valueFi : value?.valueSv);
      } else {
        return value.valueEn;
      }
    }

    if (this.lang === 'sv') {
      if (value?.valueSv === '') {
          return value?.valueEn;
      } else {
        return value?.valueSv;
      }
    }
   /* if ( _.isEqual(this.lang, 'fi') ) {
      if (_.isEqual(value.valueEn, '') && !_.isEqual(AppConfig.PRIMARY_LANGUAGE, 'fi')) {
        if (_.isEqual(AppConfig.PRIMARY_LANGUAGE, 'en')) {
          return value.valueEn;
        }
        if (_.isEqual(AppConfig.PRIMARY_LANGUAGE, 'sv')) {
          return value.valueSv;
        }
      } else {
        return value.valueFi;
      }
    }
    if ( _.isEqual(this.lang, 'sv') ) {
      if (_.isEqual(value.valueEn, '') && !_.isEqual(AppConfig.PRIMARY_LANGUAGE, 'sv')) {
        if (_.isEqual(AppConfig.PRIMARY_LANGUAGE, 'fi')) {
          return value.valueFi;
        }
        if (_.isEqual(AppConfig.PRIMARY_LANGUAGE, 'en')) {
          return value.valueEn;
        }
      } else {
        return value.valueSv;
      }
    }
    if ( _.isEqual(this.lang, 'en') ) {
      if (_.isEqual(value.valueEn, '') && !_.isEqual(AppConfig.PRIMARY_LANGUAGE, 'en')) {
        if (_.isEqual(AppConfig.PRIMARY_LANGUAGE, 'fi')) {
          return value.valueFi;
        }
        if (_.isEqual(AppConfig.PRIMARY_LANGUAGE, 'sv')) {
          return value.valueSv;
        }
      } else {
        return value.valueEn;
      }
    }*/
  }

  /**
   * For URL purposes
  */
 getDegreeProgramme(): any {
  if (this.lang === 'fi') {
    return 'ohjelma';
  }
  if (this.lang === 'en') {
    return 'programme';
  }
  if (this.lang === 'sv') {
    return 'program';
  }
 }
  getLocalizedStudyModule(): any {
    if (this.lang === 'fi') {
      return 'opintokokonaisuus';
    }
    if (this.lang === 'en') {
      return 'study-module';
    }
    if (this.lang === 'sv') {
      return 'studiehelhet';
    }
  }

  getLocalizedCategory(): any {
    if (this.lang === 'fi') {
      return 'ryhmittely';
    }
    if (this.lang === 'en') {
      return 'category';
    }
    if (this.lang === 'sv') {
      return 'gruppering';
    }
  }

  getLocalizedOffering(): any {
    if (this.lang === 'fi') {
      return 'erillinen-opintokokonaisuus';
    }
    if (this.lang === 'en') {
      return 'offering';
    }
    if (this.lang === 'sv') {
      return 'separat-studiehelhet';
    }
  }
  getLocalizedCourse(): any {
    if (this.lang === 'fi') {
      return 'opintojakso';
    }
    if (this.lang === 'en') {
      return 'course';
    }
    if (this.lang === 'sv') {
      return 'kurs';
    }
  }

  getAcademicYear(): any {
    if (this.lang === 'fi') {
      return this.academicYear.valueFi;
    }
    if (this.lang === 'en') {
      return this.academicYear.valueEn;
    }
    if (this.lang === 'sv') {
      return this.academicYear.valueSv;
    }
  }

  getAutumn(): any {
    if (this.lang === 'fi') {
      return this.autumn.valueFi;
    }
    if (this.lang === 'en') {
      return this.autumn.valueEn;
    }
    if (this.lang === 'sv') {
      return this.autumn.valueSv;
    }
  }

  getSpring(): any {
    if (this.lang === 'fi') {
      return this.spring.valueFi;
    }
    if (this.lang === 'en') {
      return this.spring.valueEn;
    }
    if (this.lang === 'sv') {
      return this.spring.valueSv;
    }
  }


  getCurrentUrl(lang: string): any {
    if (lang == 'fi') {
      return this.currentUrl.valueFi;
    }
    if (lang == 'en') {
      return this.currentUrl.valueEn;
    }
    if (lang == 'sv') {
      return this.currentUrl.valueSv;
    }
  }

  getCurrentUrlExcludingQueryParams(lang: string): any {
    if (lang == 'fi') {
      return this.currentUrl.valueFi.split('?')[0];
    }
    if (lang == 'en') {
      return this.currentUrl.valueEn.split('?')[0];
    }
    if (lang == 'sv') {
      return this.currentUrl.valueSv.split('?')[0];
    }
  }


  getLocalizedStudyModuleType(lang: string, type: string): any {
    if (lang == 'fi') {
      if (type === 'CATEGORY') {
      return 'ryhmittely';
      }
      if (type === 'STUDY_MODULE') {
        return 'opintokokonaisuus';
      }
      if (type === 'OFFERING') {
        return 'erillinen-opintokokonaisuus';
      }
    }
    if (lang == 'en') {
      if (type === 'CATEGORY')  {
        return 'category';
      }
      if (type === 'STUDY_MODULE') {
        return 'study-module';
      }
      if (type === 'OFFERING') {
        return 'offering';
      }
    }
    if (lang == 'sv') {
      if (type === 'CATEGORY')  {
        return 'category';
      }
      if (type === 'STUDY_MODULE') {
        return 'study-module';
      }
      if (type === 'OFFERING') {
        return 'offering';
      }
    }
  }

  toKebabCase(str: any): any {
    return str != '' ? str
    .replace(/['"`]/g, '')
    .replace(/[äå]/g, 'a')
    .replace(/[ö]/g, 'o')
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    .map((x: string) => x.toLowerCase())
    .join('-') : '';
  }

  // tällä alustetaan kielivalinta sovellukselle urlista
  setLangFromRoute(route: ActivatedRoute) {
   return route.params.subscribe(params => {
      if (params['lang'] === 'fi') {
        this.lang = 'fi'
      }
      if (params['lang'] === 'en') {
        this.lang = 'en'
      }
      if (params['lang'] === 'sv') {
        this.lang = 'sv'
      }
    })
  }

}